import logo from "./logo.svg";
import logomenu1 from "./logomenu1.svg";
import simbolodesktop from "./simbolodesktop.svg";
import simbolomovil from "./simbolomovil.svg";
import principal from "./texture/UAM-360-003.jpg";
import casa from "./texture/casa.jpg";
import arrow from "./arrow.svg";
//* icon
import city from "./icon/city.svg";
import back from "./icon/back.svg";
import installations from "./icon/installations.svg";
import life from "./icon/life.svg";
import building from "./icon/building.svg";
import startblue from "./icon/startblue.svg";
import close_sm from "./icon/close-sm.svg";
import tache from "./icon/tache.svg";

//* hotspot
import hotspot1 from "./hotspot/hotspot.svg";
import hotspot2 from "./hotspot/hotspot1.jpg";
import hotspot3 from "./hotspot/hotspot1.png";
import hactividades from "./hotspot/hactividades.png";
import hbibloteca from "./hotspot/hbibloteca.png";
import hcafeteria from "./hotspot/hcafeteria.png";
import hCentro from "./hotspot/hCentro.png";
import hclaustro from "./hotspot/hclaustro.png";
import heden from "./hotspot/heden.png";
import hespacio from "./hotspot/hespacio.png";
import hjardinpic from "./hotspot/hjardinpic.png";
import move from "./hotspot/move.png";

//* hotspot hover
import hactividadesHover from "./hotspot/hover/hactividades.png";
import hbiblotecaHover from "./hotspot/hover/hbibloteca.png";
import hcafeteriaHover from "./hotspot/hover/hcafeteria.png";
import hCentroHover from "./hotspot/hover/hcultural.png";
import hclaustroHover from "./hotspot/hover/hclaustro.png";
import hedenHover from "./hotspot/hover/jardineden.png";
import hespacioHover from "./hotspot/hover/hespaciosonoro.png";
import hjardinpicHover from "./hotspot/hover/hjardinpicnic.png";

//* backgroudns ----
//*bibloteca
import bb1 from "./backgrounds/bibloteca/UAM-360-003.jpg";
import bb2 from "./backgrounds/bibloteca/UAM-360-004.jpg";
import bb3 from "./backgrounds/bibloteca/UAM-360-005.jpg";
import bb4 from "./backgrounds/bibloteca/UAM-360-006.jpg";
//*cafeteria
import bc1 from "./backgrounds/Cafeteria/UAM-360-028.jpg";
import bc2 from "./backgrounds/Cafeteria/UAM-360-029.jpg";
import bc3 from "./backgrounds/Cafeteria/UAM-360-030.jpg";
//*centro cultural
import bcc1 from "./backgrounds/Centro_cultural/UAM-360-001.jpg";
import bcc2 from "./backgrounds/Centro_cultural/UAM-360-002.jpg";
//*claustro
import bcl1 from "./backgrounds/Claustro/UAM-360-034.jpg";
import bcl2 from "./backgrounds/Claustro/UAM-360-035.jpg";
import bcl3 from "./backgrounds/Claustro/UAM-360-036.jpg";
//* espacio sonoro
import bes1 from "./backgrounds/Espacio_Sonoro/UAM-360-022.jpg";
import bes2 from "./backgrounds/Espacio_Sonoro/UAM-360-023.jpg";
import bes3 from "./backgrounds/Espacio_Sonoro/UAM-360-037.jpg";
//* jardin eden
import bje1 from "./backgrounds/jardin_eden/UAM-360-024.jpg";
import bje2 from "./backgrounds/jardin_eden/UAM-360-025.jpg";
import bje3 from "./backgrounds/jardin_eden/UAM-360-026.jpg";
import bje4 from "./backgrounds/jardin_eden/UAM-360-027.jpg";
//* jardin picnic
import bjp1 from "./backgrounds/Jardin_PicNic/UAM-360-031.jpg";
import bjp2 from "./backgrounds/Jardin_PicNic/UAM-360-032.jpg";
import bjp3 from "./backgrounds/Jardin_PicNic/UAM-360-033.jpg";
//* actividades
import bad1 from "./backgrounds/actividades_deportivas/UAM-360-aerial-001.jpg";
import bad2 from "./backgrounds/actividades_deportivas/UAM-360-aerial-002.jpg";
import bad3 from "./backgrounds/actividades_deportivas/UAM-360-aerial-003.jpg";
import bad4 from "./backgrounds/actividades_deportivas/UAM-360-aerial-004.jpg";

//* general
import arial3 from "./texture/general/arial3.jpg";

//*bibloteca
import b1 from "./texture/bibloteca/UAM-360-003.jpg";
import b2 from "./texture/bibloteca/UAM-360-004.jpg";
import b3 from "./texture/bibloteca/UAM-360-005.jpg";
import b4 from "./texture/bibloteca/UAM-360-006.jpg";

//*cafeteria
import c1 from "./texture/Cafeteria/UAM-360-028.jpg";
import c2 from "./texture/Cafeteria/UAM-360-029.jpg";
import c3 from "./texture/Cafeteria/UAM-360-030.jpg";
//*centro cultural
import cc1 from "./texture/Centro_cultural/UAM-360-001.jpg";
import cc2 from "./texture/Centro_cultural/UAM-360-002.jpg";
//*claustro
import cl1 from "./texture/Claustro/UAM-360-034.jpg";
import cl2 from "./texture/Claustro/UAM-360-035.jpg";
import cl3 from "./texture/Claustro/UAM-360-036.jpg";
//* espacio sonoro
import es1 from "./texture/Espacio_Sonoro/UAM-360-022.jpg";
import es2 from "./texture/Espacio_Sonoro/UAM-360-023.jpg";
import es3 from "./texture/Espacio_Sonoro/UAM-360-037.jpg";
//* jardin eden
import je1 from "./texture/jardin_eden/UAM-360-024.jpg";
import je2 from "./texture/jardin_eden/UAM-360-025.jpg";
import je3 from "./texture/jardin_eden/UAM-360-026.jpg";
import je4 from "./texture/jardin_eden/UAM-360-027.jpg";
//* jardin picnic
import jp1 from "./texture/Jardin_PicNic/UAM-360-031.jpg";
import jp2 from "./texture/Jardin_PicNic/UAM-360-032.jpg";
import jp3 from "./texture/Jardin_PicNic/UAM-360-033.jpg";
//* actividades
import ad1 from "./texture/actividades_deportivas/UAM-360-aerial-001.jpg";
import ad2 from "./texture/actividades_deportivas/UAM-360-aerial-002.jpg";
import ad3 from "./texture/actividades_deportivas/UAM-360-aerial-003.jpg";
import ad4 from "./texture/actividades_deportivas/UAM-360-aerial-004.jpg";

//* lear more
import learnlibrary1 from "./conoce/bibloteca/Biblioteca2.jpeg";
import learnlibrary2 from "./conoce/bibloteca/Biblioteca4.jpeg";
import learncafeteria1 from "./conoce/cafeteria/CAFETERIABARRA.jpg";
import learncafeteria2 from "./conoce/cafeteria/CAFETERIAFACHADALATERAL.jpg";
import learnsport1 from "./conoce/deportivo/airelibre.jpg";
import learnsport2 from "./conoce/deportivo/basquetygym.jpg";
import learnsound1 from "./conoce/espaciosonoro/ESOACIOSONORO3.jpg";
import learnsound2 from "./conoce/espaciosonoro/ESPACIOSONORO1.jpg";
import learngardenentrada1 from "./conoce/jardinentrada/JardínentradaHueso.jpg";
import learngardenentrada2 from "./conoce/jardinentrada/Jardínentradahueso3.jpg";
import learncentro1 from "./conoce/centrocultural/CENTROCULTURAL1.jpg";
import learncentro2 from "./conoce/centrocultural/CENTROCULTURAL2.jpeg";
import learnclaustro1 from "./conoce/claustro/claustro1.jpg";
import learnclaustro2 from "./conoce/claustro/claustro2.jpg";
import learneden1 from "./conoce/jardineden/eden.jpg";
import learneden2 from "./conoce/jardineden/eden1.jpg";

export const Assets = {
	arrow,
	general: {
		logo,
		logomenu1,
		simbolodesktop,
		simbolomovil,
	},
	hotspot: {
		hotspot1,
		hotspot2,
		hotspot3,
		hactividades,
		hCentro,
		hbibloteca,
		hcafeteria,
		hclaustro,
		heden,
		hespacio,
		hjardinpic,
		move,
		hover: {
			hactividadesHover,
			hbiblotecaHover,
			hcafeteriaHover,
			hCentroHover,
			hclaustroHover,
			hedenHover,
			hespacioHover,
			hjardinpicHover,
		},
	},
	texture: {
		actividades_deportivas: {
			ad1,
			ad2,
			ad3,
			ad4,
		},
		bibloteca: {
			b1,
			b2,
			b3,
			b4,
		},
		cafeteria: {
			c1,
			c2,
			c3,
		},
		centro_cultura: {
			cc1,
			cc2,
		},
		claustro: {
			cl1,
			cl2,
			cl3,
		},
		espacio_sonoro: {
			es1,
			es2,
			es3,
		},
		jardin_eden: {
			je1,
			je2,
			je3,
			je4,
		},
		jardin_picnic: {
			jp1,
			jp2,
			jp3,
		},
		general: {
			arial3,
		},
		principal,
		casa,
	},
	backgrounds: {
		actividades_deportivas: {
			bad1,
			bad2,
			bad3,
			bad4,
		},
		bibloteca: {
			bb1,
			bb2,
			bb3,
			bb4,
		},
		cafeteria: {
			bc1,
			bc2,
			bc3,
		},
		centro_cultura: {
			bcc1,
			bcc2,
		},
		claustro: {
			bcl1,
			bcl2,
			bcl3,
		},
		espacio_sonoro: {
			bes1,
			bes2,
			bes3,
		},
		jardin_eden: {
			bje1,
			bje2,
			bje3,
			bje4,
		},
		jardin_picnic: {
			bjp1,
			bjp2,
			bjp3,
		},
	},
	icon: {
		city,
		back,
		installations,
		life,
		building,
		startblue,
		close_sm,
		tache,
	},
	learnMore: {
		actividades_deportivas: {
			learnsport1,
			learnsport2,
		},
		bibloteca: {
			learnlibrary1,
			learnlibrary2,
		},
		cafeteria: {
			learncafeteria1,
			learncafeteria2,
		},
		centro_cultura: {
			learncentro1,
			learncentro2,
		},
		claustro: {
			learnclaustro1,
			learnclaustro2,
		},
		espacio_sonoro: {
			learnsound1,
			learnsound2,
		},
		jardin_eden: { learneden1, learneden2 },
		jardin_picnic: {
			learngardenentrada1,
			learngardenentrada2,
		},
	},
};
